// extracted by mini-css-extract-plugin
export default {"errorWrapper":"_3xLg4","icon":"nIQ-Z"};